import React from 'react';

const colorMap = {
  red: {
    idle: 'bg-gray-700 border-gray-600 border-b-gray-800 text-gray-300 hover:bg-gray-600',
    active: 'bg-red-700 border-red-600 border-b-red-900 text-white shadow-[0_0_8px_rgba(239,68,68,0.5)]'
  },
  green: {
    idle: 'bg-gray-700 border-gray-600 border-b-gray-800 text-gray-300 hover:bg-gray-600',
    active: 'bg-green-700 border-green-600 border-b-green-900 text-white shadow-[0_0_8px_rgba(34,197,94,0.5)]'
  },
  amber: {
    idle: 'bg-gray-700 border-gray-600 border-b-gray-800 text-gray-300 hover:bg-gray-600',
    active: 'bg-amber-600 border-amber-500 border-b-amber-800 text-white shadow-[0_0_8px_rgba(245,158,11,0.5)]'
  },
  blue: {
    idle: 'bg-gray-700 border-gray-600 border-b-gray-800 text-gray-300 hover:bg-gray-600',
    active: 'bg-blue-700 border-blue-600 border-b-blue-900 text-white shadow-[0_0_8px_rgba(59,130,246,0.5)]'
  },
  gray: {
    idle: 'bg-gray-700 border-gray-600 border-b-gray-800 text-gray-300 hover:bg-gray-600',
    active: 'bg-gray-500 border-gray-400 border-b-gray-700 text-white'
  }
};

export const ConsoleButton = ({
  children,
  onClick,
  color = 'gray',
  active = false,
  disabled = false,
  className = '',
  title
}) => {
  const colors = colorMap[color] || colorMap.gray;
  const state = active ? colors.active : colors.idle;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`
        border-2 rounded-sm font-mono text-xs uppercase tracking-wider font-bold
        shadow-[inset_0_1px_0_rgba(255,255,255,0.1)]
        active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.5)]
        active:translate-y-px
        disabled:opacity-30 disabled:cursor-not-allowed
        transition-all duration-75
        ${state}
        ${className}
      `}
    >
      {children}
    </button>
  );
};
